import { Link } from "react-router-dom";
import useRouterErrorHandler from "@/hooks/useRouterErrorHandler";
import { reloadPage } from "@/utils/utils";
import ErrorFallback from "@/components/ui/errors/ErrorFallback";

const ErrorBoundary = () => {
  const { error } = useRouterErrorHandler();

  return (
    <div className="brand-container flex min-h-screen max-w-screen-md flex-col items-center justify-between py-8 text-center">
      <Link to="/" className="inline-block w-48">
        <img
          src="/images/yuancoffee-logo-horizontal.svg"
          className="h-auto w-full"
          alt="小院咖啡 Logo"
        />
      </Link>
      <ErrorFallback error={error} handleResetError={reloadPage} />
      <Link to="/" className="inline-block">
        <button className="brand-btn-base btn btn-primary">返回首頁</button>
      </Link>
    </div>
  );
};

export default ErrorBoundary;
